import { OptionItem } from '@domgen/dgx-fe-dynamic-form-builder';

export const purchasePriceOptions: OptionItem[] = [
  {
    label: '£1 - £199',
    value: '199',
  },
  {
    label: '£200 - £399',
    value: '399',
  },
  {
    label: '£400 - £599',
    value: '599',
  },
  {
    label: '£600 - £799',
    value: '799',
  },
  {
    label: '£800 - £999',
    value: '999',
  },
  {
    label: '£1000 - £1499',
    value: '1499',
  },
  {
    label: '£1500 - £2000',
    value: '2000',
  },
];

export const mobilePurchasePriceOptions: OptionItem[] = [
  {
    label: '£1 - £299',
    value: '299',
  },
  {
    label: '£300 - £399',
    value: '399',
  },
  {
    label: '£400 - £499',
    value: '499',
  },
  {
    label: '£500 - £599',
    value: '599',
  },
  {
    label: '£600 - £799',
    value: '799',
  },
  {
    label: '£800 - £999',
    value: '999',
  },
  {
    label: '£1000+',
    value: '1000',
  },
];
